/**
 * ColorPicker modules
 */
export * from './color-picker';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-inputs/src/color-picker/index.js
// module id = 1888
// module chunks = 0